module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_9006.098a09f7.png";